/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Wc_Guides_Reading_TimeInputs */

const en_wc_guides_reading_time = /** @type {(inputs: Wc_Guides_Reading_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min read`)
};

/**
* | output |
* | --- |
* | "{minutes} min read" |
*
* @param {Wc_Guides_Reading_TimeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_guides_reading_time = /** @type {((inputs: Wc_Guides_Reading_TimeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Guides_Reading_TimeInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_guides_reading_time(inputs)
});
export { wc_guides_reading_time as "wc.guides.reading_time" }